// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file segment-message.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file segment-message.proto.
 */
export const file_segment_message: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChVzZWdtZW50LW1lc3NhZ2UucHJvdG8iZQoOU2VnbWVudE1lc3NhZ2USGwoTZW50aXJlX21lc3NhZ2VfaGFzaBgBIAEoDBINCgVpbmRleBgCIAEoDRIWCg5zZWdtZW50c19jb3VudBgDIAEoDRIPCgdwYXlsb2FkGAQgASgMYgZwcm90bzM',
  )

/**
 * @generated from message SegmentMessage
 */
export type SegmentMessage = Message<'SegmentMessage'> & {
  /**
   * hash of the entire original message
   *
   * @generated from field: bytes entire_message_hash = 1;
   */
  entireMessageHash: Uint8Array

  /**
   * Index of this segment within the entire original message
   *
   * @generated from field: uint32 index = 2;
   */
  index: number

  /**
   * Total number of segments the entire original message is divided into
   *
   * @generated from field: uint32 segments_count = 3;
   */
  segmentsCount: number

  /**
   * The payload data for this particular segment
   *
   * @generated from field: bytes payload = 4;
   */
  payload: Uint8Array
}

/**
 * Describes the message SegmentMessage.
 * Use `create(SegmentMessageSchema)` to create a new message.
 */
export const SegmentMessageSchema: GenMessage<SegmentMessage> =
  /*@__PURE__*/
  messageDesc(file_segment_message, 0)
